import * as React from "react";
import {Dropdown, DropdownButton} from "react-bootstrap";
import {Link} from "react-router-dom";
import {routes} from "./Routes";

export type AdminMenuDropdownProps = {
    icon: React.ReactNode;
    routes: typeof routes[number]['routes'];
};

// This deployment only ever exposes a fixed, small set of pages (report/task/employee) to
// every logged-in user of the single company it's scoped to - there's no per-role menu
// visibility concept here, so the menu is just the static route list, unfiltered.
export const AdminMenuDropdown = (props: AdminMenuDropdownProps) => {
    const { icon, routes: displayRoutes } = props;

    if (displayRoutes.length === 0) {
        return null;
    }

    return (
        <DropdownButton
            id="dropdown-basic-button"
            title={icon}
            variant="outline-dark"
            size="sm"
        >
            {displayRoutes.map(route => (
                <Dropdown.Item key={route.menuId}>
                    <Link to={route.pathname}>{route.menuName}</Link>
                </Dropdown.Item>
            ))}
        </DropdownButton>
    );
};
